<template>
    <div>
        <div class="title" :style="getTitleStyle()">
            {{ myObj.bottom_list_avatar_params.title }}
        </div>
        <div class="list-box" :style="getListBoxStyle()">
            <div v-for="(item, index) in 20" :key="index" class="item" :style="getItemStyle()">
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BottomListAvatarView",
    props: ['obj'],
    data() {
        return {
            myObj: this.obj
        }
    },
    methods: {
        getTitleStyle() {
            return `margin-left: ${this.obj.bottom_list_avatar_params.margin}px`
        },
        getListBoxStyle() {
            return `padding-left: ${this.obj.bottom_list_avatar_params.margin}px;` +
                `gap: ${this.obj.bottom_list_avatar_params.between_space}px;`
        },
        getItemStyle() {
            // 圆角
            const corner_radius = this.obj.bottom_list_avatar_params.corner_radius
            // 宽高
            const screen_width = 375
            var column = this.obj.bottom_list_avatar_params.column
            const margin = this.obj.bottom_list_avatar_params.margin
            const between_space = this.obj.bottom_list_avatar_params.between_space
            const itemWidth = Math.floor((screen_width - margin * 2 - between_space * (column - 1)) / column)
            var itemHeight = itemWidth
            const style = `width:${itemWidth}px;
                        height:${itemHeight}px;
                        border-radius:${corner_radius}px; `
            return style
        },
    }
}
</script>

<style scoped lang="less">
.title {
    color: black;
    font-size: medium;
    line-height: 40px;
}

.list-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;

    .item {
        background-color: lightsteelblue;
        width: 100%;
        height: 40px;
    }
}
</style>